module.exports = __webpack_public_path__ + "static/showreel_2023-8a65eb3ecd2a8980a0a66ae799c142a9.mp4";